import { defineMessages } from "react-intl";

export const messages = defineMessages({
  installExternalApp: {
    id: "puUvKO",
    defaultMessage: "Install external app",
    description: "button",
  },
  appManifestUrlHint: {
    id: "z2yYL3",
    defaultMessage: "Usually ends with /api/manifest",
    description: "hint",
  },
});
